import React from "react"
import { IndicacoesAmigosContextProvider } from "./context/IndicacoesAmigosContextProvider"
import { IndicacoesAmigos } from "./IndicacoesAmigos"

export function Index() {
    return (
        <IndicacoesAmigosContextProvider>
            <IndicacoesAmigos />
        </IndicacoesAmigosContextProvider>
    )
}
